import { render, staticRenderFns } from "./healthList.vue?vue&type=template&id=6e17cca4&scoped=true"
import script from "./healthList.vue?vue&type=script&lang=js"
export * from "./healthList.vue?vue&type=script&lang=js"
import style0 from "./healthList.vue?vue&type=style&index=0&id=6e17cca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17cca4",
  null
  
)

export default component.exports